import { render, staticRenderFns } from "./NewCartList.vue?vue&type=template&id=ec0c29ec&scoped=true&"
import script from "./NewCartList.vue?vue&type=script&lang=js&"
export * from "./NewCartList.vue?vue&type=script&lang=js&"
import style0 from "./NewCartList.vue?vue&type=style&index=0&id=ec0c29ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0c29ec",
  null
  
)

export default component.exports